export default "<div class=\"wrapper\">\n    <router-outlet></router-outlet>   \n</div>"